export const copyObject = (val: any) => JSON.parse(JSON.stringify(val));
